// COMMITMENTT PWA helpers — coordinated with the push service worker (single /sw.js).
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; listeners.forEach((fn) => fn(false)); });
}

export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
export function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}
export function canInstall() { return !!deferredPrompt; }
export function onInstallableChange(fn) { listeners.add(fn); return () => listeners.delete(fn); }

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  deferredPrompt.prompt();
  const res = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((f) => f(false));
  return res;
}

export function registerServiceWorker(onUpdate) {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      if (reg.waiting) onUpdate && onUpdate(reg);
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) onUpdate && onUpdate(reg);
        });
      });
    }).catch(() => {});
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return; refreshing = true; window.location.reload();
    });
  });
}

export function applyUpdate(reg) {
  if (reg && reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
}

// In dev/preview the CRA hot-reload websocket + SW controllerchange reload
// cause a refresh loop. Unregister any previously-installed SW and clear caches.
export function unregisterServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  }).catch(() => {});
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}
